module.exports = __webpack_public_path__ + "img/tendencias-2022.webp";